import { isFunction } from './isFunction';
export const stylesCombinatorFactory = (styles) => (...styleKeys) => {
    const flatStyles = styles.flat();
    return styleKeys
        .map((styleKey) => typeof styleKey === 'string'
        ? flatStyles.map((style) => {
            const styleValue = style?.[styleKey];
            return (isFunction(styleValue) ? styleValue() : styleValue);
        })
        : styleKey)
        .flat()
        .filter((styleKey) => !!styleKey);
};
